var _resourceSelectorFact;

import { PRESENTATION_2, PRESENTATION_3 } from '../constants/presentation';
import resourceSelectorFactory from '../utility/new/resourceSelectorFactory';
import presentation2Manifest from './2.x/manifest';
import presentation3Manifest from './3.x/manifest';
import { getAllManifests } from './all';
import resourceListSelectorFactory from '../utility/new/resourceListSelectorFactory';
import byIdSelectorFactory from '../utility/new/byIdSelectorFactory';

var manifest = resourceSelectorFactory('manifests', (_resourceSelectorFact = {}, _resourceSelectorFact[PRESENTATION_2] = presentation2Manifest, _resourceSelectorFact[PRESENTATION_3] = presentation3Manifest, _resourceSelectorFact), PRESENTATION_2);

export default manifest;

export var manifests = resourceListSelectorFactory(getAllManifests, manifest);

export var manifestByIdSelector = byIdSelectorFactory(manifest, 'manifests');